import * as THREE from 'three'

const bunnyConfig = {
  color: "#b6cbd7",
  eyecolor: "#ff0000"
}

let bunny = null

let bunnyMaterial = null
let bunnyEyeMaterial = null
let bunnyBodyGeometry = null
let bunnyEarGeometry = null
let bunnyEyeGeometry = null

const createBunny = (scene, gui) => {
  if(bunny !== null) {
    bunnyMaterial.dispose()
    bunnyEyeMaterial.dispose()

    bunnyBodyGeometry.dispose()
    bunnyEarGeometry.dispose()
    bunnyEyeGeometry.dispose()
    
    scene.remove(bunny)
  }

  bunny = new THREE.Group()

  /**
   * Materials
   */

  bunnyMaterial = new THREE.MeshStandardMaterial({color: bunnyConfig.color})
  bunnyEyeMaterial = new THREE.MeshStandardMaterial({color: bunnyConfig.eyecolor})

  /**
   * Bunny elements
   */

  bunnyBodyGeometry = new THREE.BoxGeometry(3, 2, 4)
  const bunnyBodyMesh = new THREE.Mesh(bunnyBodyGeometry, bunnyMaterial)
  bunny.add(bunnyBodyMesh)
  
  bunnyEarGeometry = new THREE.BoxGeometry(1, 3, 1)
  const bunnyLeftEarMesh = new THREE.Mesh(bunnyEarGeometry, bunnyMaterial)
  bunnyLeftEarMesh.position.x = 1
  bunnyLeftEarMesh.position.y = 2
  bunnyLeftEarMesh.position.z = 1.5
  bunny.add(bunnyLeftEarMesh)

  const bunnyRightEarMesh = new THREE.Mesh(bunnyEarGeometry, bunnyMaterial)
  bunnyRightEarMesh.position.x = -1
  bunnyRightEarMesh.position.y = 2
  bunnyRightEarMesh.position.z = 1.5
  bunny.add(bunnyRightEarMesh)

  bunnyEyeGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
  const bunnyRightEyeMesh = new THREE.Mesh(bunnyEyeGeometry, bunnyEyeMaterial)
  bunnyRightEyeMesh.position.x = -1
  bunnyRightEyeMesh.position.z = 2
  bunny.add(bunnyRightEyeMesh)

  const bunnyLeftEyeMesh = new THREE.Mesh(bunnyEyeGeometry, bunnyEyeMaterial)
  bunnyLeftEyeMesh.position.x = 1
  bunnyLeftEyeMesh.position.z = 2
  bunny.add(bunnyLeftEyeMesh)

  scene.add(bunny)

  return bunny
}

const addBunnyGui = (scene, gui) => {
  const updateFromGui = () => {
    createBunny(scene, gui)
  }

  const bunnyGui = gui.addFolder('bunny')

  bunnyGui.addColor(bunnyConfig, 'color').onFinishChange(updateFromGui)
  bunnyGui.addColor(bunnyConfig, 'eyecolor').onFinishChange(updateFromGui)
}

const updateBunny = () => {
  
}

export {
  addBunnyGui,
  createBunny,
  updateBunny
}